module.exports = __webpack_public_path__ + "static/media/register.a5aff350.jpg";